// extracted by mini-css-extract-plugin
export default {"mainBox":"style_mainBox__mXkjG","constactBox":"style_constactBox__Ed9bq","iconBox":"style_iconBox__xXPFB"};